module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_8017.efef57a1.png";